/**
 * DocPageLink
 *
 * Pill-style "Open the X page" link that navigates to a live Super Admin
 * page via TanStack Router.
 */
import { Link } from '@tanstack/react-router';
import { ArrowUpRight } from 'lucide-react';
import { cn } from '@respectly/ui';

export interface DocPageLinkProps {
  to: string;
  label: string;
  className?: string;
}

export function DocPageLink({ to, label, className }: DocPageLinkProps) {
  return (
    <Link
      to={to}
      className={cn(
        'inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full',
        'bg-violet-50 dark:bg-violet-900/30 text-violet-700 dark:text-violet-300',
        'border border-violet-200/70 dark:border-violet-800/60',
        'text-xs font-medium',
        'hover:bg-violet-100 dark:hover:bg-violet-900/50 transition-colors',
        'no-underline',
        className
      )}
    >
      {label}
      <ArrowUpRight className="w-3.5 h-3.5" />
    </Link>
  );
}
